import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiTaskSharedService } from '@fi-shared/fi-task-shared/fi-task-shared.service';
import { TaskEditModule } from '@fi-shared/fi-task-shared/task-edit/task-edit.module';
import { TaskListModule } from '@fi-shared/fi-task-shared/task-list/task-list.module';
import { FiTaskHelperService } from '@fi-shared/fi-task-shared/fi-task-helper.service';
import { TaskDetailsModule } from '@fi-shared/fi-task-shared/task-details/task-details.module';
import { TasksStatusModule } from '@fi-shared/fi-task-shared/tasks-status/tasks-status.module';
import { TasksArchivedModule } from '@fi-shared/fi-task-shared/tasks-archived/tasks-archived.module';
import { FiTooltipModule } from '@fi-shared/fi-tooltip/fi-tooltip.module';
import { FiTaskSyncService } from '@fi-shared/fi-task-shared/fi-task-sync-service';

@NgModule({
    imports: [
        CommonModule,
        TaskEditModule,
        TaskListModule,
        TaskDetailsModule,
        TasksStatusModule,
        TasksArchivedModule,
        FiTooltipModule,
    ],
    providers: [FiTaskSharedService, FiTaskHelperService, FiTaskSyncService],
    exports: [TaskEditModule, TaskListModule, TaskDetailsModule, TasksArchivedModule],
})
export class FiTaskSharedModule {}
